<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import FieldHeading from './field-heading.svelte'
    import { HAIR_TYPE_OPTIONS, findHairType, type HairTypeValue } from '../../types/hair-type'

    export let label: string
    export let data: Record<string, any>
    export let value: HairTypeValue = null
    export let required = false
    export let readOnly = false

    function select(key: string) {
        if (readOnly) return
        value = key
    }

    $: selectedOption = findHairType(value)
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    <div class="hair-scale">
        {#each HAIR_TYPE_OPTIONS as option (option.key)}
            <button
                type="button"
                class="hair-row"
                class:selected={value === option.key}
                disabled={readOnly}
                on:click={() => select(option.key)}
            >
                <span class="hair-label">
                    {option.label}
                    <span class="hair-tooltip-icon" title={option.tooltip}>
                        <Fa icon={faCircleQuestion} />
                    </span>
                </span>
                <span class="hair-desc">{option.description}</span>
            </button>
        {/each}
    </div>
</div>

<style>
    .view-field {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .hair-scale {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .hair-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        width: 100%;
        padding: 10px 14px;
        border: none;
        border-radius: 8px;
        background: #f8f9fa;
        font: inherit;
        text-align: left;
        cursor: pointer;
    }
    .hair-row:disabled {
        cursor: not-allowed;
    }
    .hair-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .hair-label {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .hair-row.selected .hair-label {
        color: #1f2937;
    }
    .hair-desc {
        flex: 2;
        min-width: 0;
        text-align: right;
        font-size: 0.85rem;
        color: #495057;
    }
    .hair-row.selected .hair-desc {
        color: #1f2937;
    }
    .hair-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
        cursor: help;
    }
    .hair-row.selected .hair-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
